<template>
  <div class="banner pa-4">
    <v-container class="custom-container">
      <v-row dense>
        <v-col v-for="(graph, index) in rmsgraphs" :key="index" cols="12" sm="6" md="4" lg="3" class="pb-2">
          <v-card tile flat class="pb-0" :class="$vuetify.theme.dark ? 'blue-lighten-1' : 'white-lighten-2'">
            <div class="chart-container">
              <apexcharts :ref="`apexChart_${index}`" type="donut" :width="230" :height="300"
                :options="chartOptions(graph)" :series="[parseFloat(graph.buy), parseFloat(graph.sell)]"></apexcharts>
              <div class="center-text">{{ graph.symbol }}</div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { RMSSETTINGS__ACTIONS } from "@/store/action-types";
import VueApexCharts from "vue-apexcharts";
import { mapActions, mapState } from "vuex";

export default {
  components: { apexcharts: VueApexCharts },
  computed: {
    ...mapState("rmssettings", ["rmsgraphs"]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("rmssettings", [RMSSETTINGS__ACTIONS.RMSGRAPH]),
    addMarginToLegendMarkers() {
      this.$nextTick(() => {
        this.rmsgraphs.forEach((_, index) => {
          const apexChartEl = this.$refs[`apexChart_${index}`][0].$el;
          const legendMarkers = apexChartEl.querySelectorAll(
            ".apexcharts-legend-marker"
          );
          legendMarkers.forEach((marker) => {
            marker.style.marginRight = "10px";
          });
        });
      });
    },
    chartOptions(graph) {
      return {
        colors: ["#039de9", "#FF567F"],
        legend: {
          position: "top",
          horizontalAlign: "left",
          fontSize: "14px",
          fontFamily: "Inter",
          fontWeight: 400,
          offsetY: 10,
          labels: {
            colors: "#708AA7",
          },
          markers: {
            width: 10,
            height: 10,
          },
          itemMargin: {
            horizontal: 5,
          },
        },
        stroke: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        labels: ["Buy", "Sell"],
      };
    },
  },

  async created() {
    this.addMarginToLegendMarkers();
    await this[RMSSETTINGS__ACTIONS.RMSGRAPH]();
  },
};
</script>

<style scoped>
.chart-container {
  position: relative;
}

.center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  font-weight: 500;
  color: #708aa7;
  line-height: 26px;
}

@media (max-width: 1263.98px) {
  .center-text {
    display: none;
  }
}
</style>
